import { useEffect, useRef } from "react"
import { persistentReportStore } from "@common/scroll-boxes/scroll-box-report-ledger"
import { scrollBoxSentryEvent } from "@common/scroll-boxes/scroll-box-sentry-event"
import { MINIMUM_WHOLE_UNITS_IN_A_SCROLL_BOX } from "@common/scroll-boxes/scroll-box-verdict"
import {
  SCROLL_BOX_SETTLE_MS,
  startScrollBoxWatcher,
  type ScrollBoxReport,
  type SupportedMinimumWindow,
} from "@common/scroll-boxes/scroll-box-watcher"
import { reportMessage } from "../utils/sentry-reporter"

export const ADDIN_SUPPORTED_MINIMUM_TASKPANE: SupportedMinimumWindow = { widthPx: 320, heightPx: 480 }

function sendScrollBoxReportToSentry(report: ScrollBoxReport): void {
  const event = scrollBoxSentryEvent(report)
  reportMessage(event.message, {
    ...event.captureContext,
    tags: { ...event.captureContext.tags, "scroll_box.office_platform": String(Office.context.platform) },
  })
}

export function useScrollBoxReporting(currentPage: string): void {
  const currentPageRef = useRef(currentPage)

  useEffect(() => {
    currentPageRef.current = currentPage
  }, [currentPage])

  useEffect(() => {
    const reportStore = persistentReportStore()
    if (reportStore === null) return undefined
    return startScrollBoxWatcher({
      minimumWholeUnits: MINIMUM_WHOLE_UNITS_IN_A_SCROLL_BOX,
      settleMs: SCROLL_BOX_SETTLE_MS,
      supportedMinimumWindow: ADDIN_SUPPORTED_MINIMUM_TASKPANE,
      reportStore,
      currentRoute: () => currentPageRef.current,
      report: sendScrollBoxReportToSentry,
    })
  }, [])
}
